import React, { useRef } from 'react';
import { styled } from '@mui/system';
import emailjs from 'emailjs-com';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


const Container = styled('section')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const InfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '30px'
})

const Subtitle5 = styled('h5')({
  fontSize: '12px',
  fontWeight: '500',
  color: 'var(--color-light)',
})

const Subtitle3 = styled('h3')({
  fontSize: '18px',
  fontWeight: '700',
})

const Title = styled('h1')({
  fontSize: '30px',
  color: 'var(--color-primary)'
})

const Wrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '70%',
  '@media (max-width: 1020px)' : {
    flexDirection: 'column',
    // alignItems : 'center'
}
})

const LeftContainer = styled('div')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column'
})

const RightContainer = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column'
})

const Card = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px 60px 20px 60px',
  margin: '20px',
  borderRadius: '10px',
  backgroundColor: 'var(--color-bg-variant)',
  gap: '20px',
  minWidth: '40%',
  transition: 'all 1s ease',
  '&:hover': {
    backgroundColor: '#1f1f38',
    border: '1px solid var(--color-primary)',
    transform: 'scale(1.01)',
  },
})

const CardDescription = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  alignItems : 'center',
  gap: '5px'
})

const Content = styled('p')({
})

const SendMsg = styled('a')({
  textDecoration : 'none',
  marginTop : '20px',
  color : 'var(--color-primary)',
  '&:hover': {
    transform: 'scale(1.01)',
  },
})

const TextFiled = styled('input')({
  color : 'var(--color-white)',
  background : 'transparent',
  padding : '20px',
  margin : '20px',
  width : '80%',
  border: '1px solid var(--color-primary)',
  borderRadius : '10px'
})

const TextArea = styled('textarea')({
  color : 'var(--color-white)',
  background : 'transparent',
  padding : '20px',
  margin : '20px',
  width : '80%',
  minHeight : '30%',
  border: '1px solid var(--color-primary)',
  borderRadius : '10px'
})

const Button = styled('button')({
  backgroundColor: 'var(--color-primary)',
  color: 'var(--color-bg)',
  width : 'fit-content',
  fontWeight: '700',
  cursor: 'pointer',
  borderRadius: '5%',
  border: '1px solid var(--color-primary)',
  padding: '10px',
  marginLeft: '20px',
  transition: 'all 0.5s ease',
  boxShadow: '2px 2px 4px 4px var(--color-bg)',
  '&:hover': {
    color: 'var(--color-bg)',
    backgroundColor: 'var(--color-white)',
    borderColor: 'transparent',
    transform: 'scale(1.05)',
  },
})


function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      form.current,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then(() => {
      alert('✅ Message sent successfully!');
      e.target.reset();
    })
    .catch((error) => {
      console.error('❌ Error:', error);
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <Container id='contact'>
      <InfoContainer>
        <Subtitle5>Get in touch</Subtitle5>
        <Title>Contact Me</Title>
      </InfoContainer>

      <Wrapper>
        <LeftContainer>
          <Card>
            <EmailIcon style={{ color: 'var(--color-primary)' }} />
            <CardDescription>
              <Subtitle3>Email</Subtitle3>
              <Content>sonia.reffad.pro@gmail.com</Content>
              <SendMsg href='mailto:sonia.reffad.pro@gmail.com' target="_blank" rel="noreferrer">
                Send a message
              </SendMsg>
            </CardDescription>
          </Card>

          <Card>
            <WhatsAppIcon style={{ color: 'var(--color-primary)' }} />
            <CardDescription>
              <Subtitle3>WhatsApp</Subtitle3>
              <Content>+33 766 714 113</Content>
              <SendMsg href='https://api.whatsapp.com/send?phone=+33766714113' target="_blank" rel="noreferrer">
                Send a message
              </SendMsg>
            </CardDescription>
          </Card>
        </LeftContainer>

        <RightContainer>
          <form ref={form} onSubmit={sendEmail}>
            <TextFiled type='text' name='name' placeholder='Your Full Name ...' required />
            <TextFiled type='email' name='email' placeholder='Your Email Address ...' required />
            <TextArea name='message' placeholder='Your Message ...' required />
            <Button type='submit'>Send Message</Button>
          </form>
        </RightContainer>
      </Wrapper>
    </Container>
  );
}

export default Contact;